// 🚨 AUTO-GENERADO desde DebitnoteDataType.ts - No editar manualmente

export const DebitnoteFormDataKeys = [
  "id",
  "numero",
  "sequence",
  "document_key",
  "description",
  "email",
  "subtotal",
  "descuento",
  "discountCode",
  "impuestos",
  "impuestos_servicio",
  "total",
  "exchange_rate",
  "edocument_status",
  "edocument_status_payload",
  "created",
  "applied",
  "activitycode",
  "applied_date",
  "selected_logo",
  "excludeFromReport",
  "price_note",
  "anulada",
  "info_references",
  "otros_cargos",
  "clientId",
  "client",
  "currencyId",
  "currency",
  "invoiceId",
  "invoice",
  "appliedInvoiceId",
  "appliedInvoice",
  "debitnoteProducts",
  "user",
  "reference_number"
] as const;
